<template>
  <div>
    <div
      v-if="spells.length !== 0"
      class="image-container image-container--large"
    >
      <img
        v-for="(spell, index) in spells"
        :key="index"
        :class="['hidden', currentSpellIndex === index && 'inline']"
        :src="spell.image_url"
        alt="spell image"
      >
    </div>
    <div class="flex justify-center mt-2">
      <div
        v-for="(spell, index) in spells"
        :key="index"
        :class="['spell-icon', currentSpellIndex === index && 'spell-icon--selected']"
        :style="`background-image: url('${spell.icon_url}');`"
        @click="currentSpellIndex = index"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spells: window.spells || [],
      currentSpellIndex: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.spell-icon {
  @apply border border-almost-black;
  @apply mr-2;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  box-shadow: inset 0px 0px 0px 3px #131313;
  filter: grayscale(100%);

  &--selected {
    @apply border-smurfs-gold;
    filter: none;
  }
}
</style>
